
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { type ReactElement, type ReactNode } from "react";

import styles from "./Tooltip.module.css";

export const TOOLTIP_DELAY_MS = 300;

let escapeClosedATooltip: KeyboardEvent | null = null;

export function didTooltipConsumeEscape(event: KeyboardEvent): boolean {
  return escapeClosedATooltip !== null && escapeClosedATooltip === event;
}

function rememberTooltipEscape(event: KeyboardEvent) {
  escapeClosedATooltip = event;
  setTimeout(() => {
    if (escapeClosedATooltip === event) escapeClosedATooltip = null;
  }, 0);
}

export function TooltipProvider({ children }: { children: ReactNode }) {
  return (
    <TooltipPrimitive.Provider delayDuration={TOOLTIP_DELAY_MS}>{children}</TooltipPrimitive.Provider>
  );
}

export type TooltipProps = {
  content: ReactNode;
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
  delayDuration?: number;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  children: ReactElement;
};

export function Tooltip({
  content,
  side = "top",
  align = "center",
  delayDuration,
  open,
  onOpenChange,
  children,
}: TooltipProps) {
  if (!content) return children;

  return (
    <TooltipPrimitive.Root delayDuration={delayDuration} open={open} onOpenChange={onOpenChange}>
      <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
          className={styles.tooltip}
          side={side}
          align={align}
          sideOffset={6}
          onEscapeKeyDown={rememberTooltipEscape}
        >
          {content}
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  );
}
